import React from "react";
import './FAQs.css';
import { useState } from "react";
import faqData from "./faqData";

const FAQs = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section" id='faqs'>
            <div className="faq-title">
                <h2 className="faq-heading">Frequently Asked Questions <span className="green-text">(FAQs)</span></h2>
                {/* <div className="faq-subtitle-container">
                    <p className="faq-subtitle">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Assumenda except incidunt veniam aperiam iusto optio aliquid exercitationem non cum. Nihil.</p>
                </div> */}
            </div>
            <div className="faq-list">
                {faqData.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <div className="faq-question" onClick={() => toggleFAQ(index)}>
                            <span>{faq.question}</span>
                            <span className="faq-icon">{activeIndex === index ? "-" : "+"}</span>
                        </div>
                        {activeIndex === index && (
                            <div className="faq-answer">
                                {faq.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    )
}

export default FAQs;